export default __webpack_public_path__ + "static/media/red_envelope_icon1.e6b6e7b5.png";